import React, { Component, PropTypes } from 'react'
import { fromJS } from 'immutable'
import styled from 'styled-components'
import { translate } from 'react-i18next'
import AdminNavbar from '../../components/AdminNavbar'
import CardContainer from '../../components/CardContainer'
import Input from '../../components/Input'
import Trash from '../../svg-icons/Trash'
import { Metrics, Fonts } from '../../Themes'
import { deleteAdmin, searchAdmins } from '../../sources/AdminSource'
import DialogModal from '../../components/Modal/DialogModal'
import ThemeContainer from '../../components/ThemeContainer'

const PageContainer = styled.div`min-height: 100%;`

const CustomCardContainer = styled(CardContainer)`
  margin-top: ${Metrics.margins.base};
`

const CustomThemeContainer = styled(ThemeContainer)`
  padding-left: ${Metrics.components.customThemeSpacing} !important;
  padding-right: ${Metrics.components.customThemeSpacing} !important;
  max-height: ${Metrics.components.adminContent};
  overflow-y: scroll;
`

const SearchArea = styled.div`
  padding-bottom: ${Metrics.margins.base};
  border-bottom: ${Metrics.borders.default};
`

const Admin = styled.div`
  height: 50px;
  border-bottom: ${Metrics.borders.default};
  padding: ${Metrics.margins.base} 0;
  cursor: pointer;
  position: relative;
  svg {
    position: absolute;
    right: 0;
    top: ${Metrics.margins.medium};
    float: right;
    cursor: pointer;
  }
`

const AdminName = styled.div`${Fonts.style.Label};`

class AdminsOverview extends Component {
  constructor (props) {
    super(props)
    this.state = {
      name: '',
      modal: false,
      admins: [],
      adminToDelete: null
    }
    this.fetchAdmins = this.fetchAdmins.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.selectAdmin = this.selectAdmin.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  shouldComponentUpdate (nextProps, nextState) {
    const { name, modal, admins, adminToDelete } = this.state
    if (
      name !== nextState.name ||
      modal !== nextState.modal ||
      !fromJS(nextState.admins).equals(fromJS(admins)) ||
      adminToDelete !== nextState.adminToDelete
    ) {
      return true
    }
    return false
  }

  componentWillMount () {
    this.fetchAdmins()
  }

  fetchAdmins () {
    searchAdmins({ sort: 'name ASC' })
      .then(response => this.setState({ admins: response.data }))
      .catch(error => {
        console.error(error)
      })
  }

  handleDelete () {
    deleteAdmin(this.state.adminToDelete.id)
      .then(response => {
        this.setState({ adminToDelete: null, modal: false }, () =>
          this.fetchAdmins()
        )
      })
      .catch(error => console.log(error))
  }

  selectAdmin (admin) {
    this.setState({ adminToDelete: admin, modal: true })
  }

  handleChange (event) {
    this.setState({ name: event.target.value }, () => {
      searchAdmins({
        where: { name: { startsWith: this.state.name } },
        sort: 'name ASC'
      })
        .then(response => this.setState({ admins: response.data }))
        .catch(error => console.log(error))
    })
  }

  render () {
    let { name, admins, modal } = this.state

    let { t, admin, dropdownLinks, router } = this.props

    return (
      <PageContainer>
        <AdminNavbar
          fixedSearchBar
          admin={admin}
          rightSideActions={[
            {
              label: t('Create Admin'),
              secondary: true,
              onClick: () => router.push('/admin/admins/new')
            }
          ]}
          dropdownLinks={dropdownLinks}
        />
        <DialogModal
          visible={modal}
          header={t('Delete Admin')}
          message={t('Do you really want to delete this admin?')}
          buttons={{
            apply: { label: t('Delete'), onClick: this.handleDelete },
            cancel: {
              label: t('Cancel'),
              onClick: () => {
                this.setState({ modal: false })
              }
            }
          }}
          closeAction={this.toggleModal}
        />
        <CustomThemeContainer>
          <CustomCardContainer title={t('Admins')}>
            <SearchArea>
              <Input
                placeholder={t('Search for admins')}
                title={t('Name')}
                handleChange={this.handleChange}
                value={name}
                name='name'
              />
            </SearchArea>
            {admins &&
              admins.length > 0 &&
              admins.map((el, index) => {
                return (
                  <Admin
                    key={`admin-${index}`}
                    onClick={() => router.push(`/admin/admins/${el.id}`)}>
                    <AdminName>{el.name}</AdminName>
                    {admin.email !== el.email && (
                      <Trash
                        onClick={event => {
                          event.stopPropagation()
                          this.selectAdmin(el)
                        }}
                      />
                    )}
                  </Admin>
                )
              })}
          </CustomCardContainer>
        </CustomThemeContainer>
      </PageContainer>
    )
  }
}

AdminsOverview.propTypes = {
  t: PropTypes.func,
  router: PropTypes.object,
  admin: PropTypes.object,
  dropdownLinks: PropTypes.array
}

export default translate([ 'common', 'admin', 'forms' ], { wait: true })(
  AdminsOverview
)



// WEBPACK FOOTER //
// ./src/pages/AdminAdmins/AdminsOverview.js